@if (isVisible) {
  <div
    class="fixed top-4 left-4 right-4 sm:top-6 sm:right-6 sm:left-auto z-9999 bg-surface-100/95 backdrop-blur-xl rounded-xl border border-subtle p-4 sm:p-5 w-full max-w-sm transform transition-all duration-300 ease-out animate-slide-down"
  [ngClass]="{
    'border-l-2 border-l-success': type === 'success',
    'border-l-2 border-l-danger': type === 'error',
    'border-l-2 border-l-info': type === 'info',
    'border-l-2 border-l-warning': type === 'warning'
  }">
    <!-- Close Button -->
    <button
      class="absolute top-3 right-3 text-muted hover:text-text-strong rounded p-1 transition-colors duration-200"
      (click)="dismissToast()" aria-label="Close notification">
      <i class="fas fa-times text-xs"></i>
    </button>
    <!-- Toast Content -->
    <div class="flex items-start space-x-3">
      <!-- Icon Container -->
      <div class="shrink-0">
        <div class="w-8 h-8 rounded-lg flex items-center justify-center" [ngClass]="{
            'bg-success/10': type === 'success',
            'bg-danger/10': type === 'error',
            'bg-info/10': type === 'info',
            'bg-warning/10': type === 'warning'
          }">
          @if (type === 'success') {
            <i class="fas fa-check-circle text-sm text-success"></i>
          }
          @if (type === 'error') {
            <i class="fas fa-exclamation-circle text-sm text-danger"></i>
          }
          @if (type === 'info') {
            <i class="fas fa-info-circle text-sm text-info"></i>
          }
          @if (type === 'warning') {
            <i class="fas fa-exclamation-triangle text-sm text-warning"></i>
          }
        </div>
      </div>
      <!-- Message Content -->
      <div class="flex-1 min-w-0">
        <h4 class="text-text-strong font-display font-bold text-sm leading-tight mb-0.5">{{ title }}</h4>
        <p class="text-muted-light text-xs leading-relaxed">{{ message }}</p>
      </div>
    </div>
    <!-- Progress Bar -->
    <div class="mt-3 w-full bg-subtle h-0.5 rounded-full overflow-hidden">
      <div class="h-full rounded-full transition-all duration-300 ease-out" [ngClass]="{
          'bg-success': type === 'success',
          'bg-danger': type === 'error',
          'bg-info': type === 'info',
          'bg-warning': type === 'warning'
        }" [style.width.%]="progressWidth">
      </div>
    </div>
  </div>
}
